"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isNumber_1 = __importDefault(require("lodash/isNumber"));
var toNumber_1 = __importDefault(require("lodash/toNumber"));
var CurrencyUtil = /** @class */ (function () {
    function CurrencyUtil() {
    }
    CurrencyUtil.parseCurrency = function (stringOrNumber, withCurrency) {
        if (withCurrency === void 0) { withCurrency = false; }
        var value = toNumber_1.default(stringOrNumber);
        if (isNumber_1.default(value) && !isNaN(value)) {
            if (withCurrency) {
                return new Intl.NumberFormat('ja-JP', {
                    style: 'currency',
                    currency: 'JPY',
                }).format(value);
            }
            else {
                return new Intl.NumberFormat('ja-JP').format(value);
            }
        }
        return undefined;
    };
    return CurrencyUtil;
}());
exports.default = CurrencyUtil;
//# sourceMappingURL=CurrencyUtil.js.map